import { connectModal } from 'redux-modal'
import { connect } from 'react-redux'
import { branch, renderNothing, withHandlers } from 'recompose'
import { compose } from 'redux'
import AddressConfirmationModal from './AddressConfirmationModal'
import { ADDRESS_CONFIRMATION_MODAL } from './constants'
import { handleChooseAddress } from '../PersonalInformationDrawer/actions'

const withHiddenState = branch(
  ({ show }) => !show,
  renderNothing
)

const withChooseAddressHandlers = withHandlers({
  handleUseEnteredAddress: ({ handleChooseAddress, accountDetails }) => () => {
    handleChooseAddress({
      ...accountDetails,
      usedSuggestedAddress: false,
      addressKeepAsIs: true
    })
  },
  handleUseVerifiedAddress: ({ handleChooseAddress, accountDetails, verifiedAddress }) => () => {
    handleChooseAddress({
      ...accountDetails,
      ...verifiedAddress,
      usedSuggestedAddress: true,
      addressKeepAsIs: false
    })
  }
})

export default compose(
  connect(null, { handleChooseAddress }),
  connectModal({
    name: ADDRESS_CONFIRMATION_MODAL
  }),
  withHiddenState,
  withChooseAddressHandlers
)(AddressConfirmationModal)
